/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ChatParticipant = {
  /**
   * Directory display name at capture time.
   */
  displayName?: string | undefined;
  /**
   * Directory provider that identifies this conversation participant.
   */
  provider: string;
  /**
   * Workspace resolved from the organization directory, when unambiguous.
   */
  providerTeamId?: string | undefined;
  /**
   * Provider identity observed in the message envelope.
   */
  providerUserId: string;
  /**
   * Explicitly mapped Speakeasy person at capture time; this attribution grants no permissions.
   */
  userId?: string | undefined;
};

/** @internal */
export const ChatParticipant$inboundSchema: z.ZodMiniType<
  ChatParticipant,
  unknown
> = z.pipe(
  z.object({
    display_name: z.optional(z.string()),
    provider: z.string(),
    provider_team_id: z.optional(z.string()),
    provider_user_id: z.string(),
    user_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "provider_team_id": "providerTeamId",
      "provider_user_id": "providerUserId",
      "user_id": "userId",
    });
  }),
);

export function chatParticipantFromJSON(
  jsonString: string,
): SafeParseResult<ChatParticipant, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ChatParticipant$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ChatParticipant' from JSON`,
  );
}
